import { lsget } from './misc'

export const getHeaders = (): Headers | undefined => {
  const token = lsget('token')
  const user = lsget('user')
  if (!token) {
    window.location.reload()
    return
  }
  const headers = new Headers()
  headers.append('Access-key', token)

  return headers
}
